export const brandImageLinks = [
  '/homepage/brands/KohlerLogo.svg',
  '/homepage/brands/Nuevo-Logo.svg',
  '/homepage/brands/KitchenAidLogo.svg',
  '/homepage/brands/SamsungLogo.svg',
  '/homepage/brands/ElectroluxLogo.svg',
  '/homepage/brands/EQ3Logo.svg',
  '/homepage/brands/SimmonsLogo.svg',
  '/homepage/brands/MasterBrandLogo.svg',
  '/homepage/brands/Sherwin WilliamsLogo.svg',
  '/homepage/brands/Hooker FurnitureLogo.svg',
  '/homepage/brands/AshleyLogo.svg',
  '/homepage/brands/DaltileLogo.svg',
  '/homepage/brands/PalliserLogo.svg',
  '/homepage/brands/GenerationLighting.svg',
  '/homepage/brands/SunpanLogo.svg',
  '/homepage/brands/WhirlpoolLogo.svg',
  '/homepage/brands/Four HandsLogo.svg',
  '/homepage/brands/KirschLogo.svg'
];
